import { Modal } from "antd";
import FooterModal from "ui/components/Button/FooterModal";
import { Text } from "@chakra-ui/layout";

interface ModalConfirmarArrecadacaoVencidaProps {
  isOpen: boolean;
  onSubmit: () => any;
  onClose: () => any;
  numeroArrecadacoesVencidas: number;
  numeroArrecadacoesSelecionadas: number;
}

function ModalConfirmarArrecadacaoVencida({
  isOpen,
  onClose,
  onSubmit,
  numeroArrecadacoesSelecionadas,
  numeroArrecadacoesVencidas,
}: ModalConfirmarArrecadacaoVencidaProps) {
  const getTextPrefix = () => {
    let text = ``;
    if (numeroArrecadacoesVencidas === numeroArrecadacoesSelecionadas) {
      text += `Todas as arrecadações têm data de vencimento anterior a hoje.`;
    } else if (numeroArrecadacoesVencidas === 1) {
      text += `Uma arrecadação tem data de vencimento anterior a hoje.`;
    } else {
      text += `Existem algumas arrecadações com data de vencimento anterior a hoje.`;
    }

    return text;
  };

  const getTextSuffix = () => {
    let text = ``;
    if (numeroArrecadacoesSelecionadas > numeroArrecadacoesVencidas) {
      text += `As arrecadações com vencimento futuro serão geradas normalmente. `;
    }
    text += "Deseja continuar?";

    return text;
  };

  return (
    <Modal
      centered
      visible={isOpen}
      footer={
        <FooterModal
          showRegisterAnother={false}
          onClose={onClose}
          onSubmit={onSubmit}
          buttonCancelarText="Não"
          primaryButtonText="Sim"
        />
      }
      title={"Confirmar ação"}
      destroyOnClose
      onCancel={onClose}
      closable={true}
      width="600px"
      keyboard={false}
    >
      <Text mt={-4}>
        {getTextPrefix()} Se clicar em continuar, para elas serão geradas
        receitas para fins de controle, mas{" "}
        <Text fontWeight="bold" display="inline">
          não
        </Text>{" "}
        serão gerados / registrados os boletos. {getTextSuffix()}
      </Text>
    </Modal>
  );
}

export default ModalConfirmarArrecadacaoVencida;
